import { useTranslation } from 'react-i18next';
import type { PageType } from 'types';
import type { HotDealsModule } from 'types/capi/modules';

import ProductCard from '~/components/ProductCard';
import Tracked from '~/components/Tracked';

type Props = { items: HotDealsModule['items']; pageType: PageType };

function Products({ items, pageType }: Props) {
  return (
    <div className={`grid shrink-0 grid-cols-2 gap-2 md:grid-cols-4 md:gap-6`}>
      {items.map((product, productIndex) => (
        <ProductCard.Internal
          key={`product-${productIndex}`}
          product={product}
          padImage
          className={`w-full ${productIndex > 3 ? 'hidden md:flex' : ''}`}
          allowNotifications
          imageLoading="eager"
          cardSize="small"
          showNotificationCount={true}
          position={productIndex + 1}
          pageType={pageType}
          pagePosition="Homepage Hot Deals"
          overrideInteractionPagePosition={true}
        />
      ))}
    </div>
  );
}

function ViewMoreButton() {
  const { t } = useTranslation('common');

  return (
    <div className="w-36">
      <Tracked.InternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Hot Deals"
        name="VIEW_MORE"
        to={`release-dates/?sort=SALE`}
      >
        {t('viewMore')}
      </Tracked.InternalLink>
    </div>
  );
}

export default function HotDeals({ items, pageType }: Props) {
  const { t } = useTranslation('home');

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center gap-6 px-0 py-10 md:mx-auto md:max-w-6xl md:gap-10 md:py-10">
        <div className="flex flex-col gap-6 self-stretch py-0 pl-4 md:gap-10">
          <div className="flex flex-col gap-2">
            <h2 className="flex flex-col justify-start gap-2 text-left text-[32px] leading-10 md:text-[40px] md:leading-[48px]">
              {t('hotDeals')}
            </h2>
            <div className="text-base md:text-lg">
              {t('hotDealsDescription')}
            </div>
          </div>
          <Products items={items} pageType={pageType} />
        </div>
        <ViewMoreButton />
      </div>
    </div>
  );
}
